const warningIconStyle = ({ iconFontFamily = 'MsAds MDL2 Assets', fontSize = 14 }) => ({
  fontFamily: iconFontFamily,
  fontSize,
  fontWeight: 'normal',
  lineHeight: '16px',
  color: '#D83B01',
  '&:before': {
    content: '"\\E7BA"',
    marginRight: 2,
  },
});

export const locationCellStatusStyle = ({ iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .col-icon .alert-icon.warning': warningIconStyle({ iconFontFamily }),

  '& .col-location, & .location-map-item': {
    '& .alert-icon.warning': warningIconStyle({ iconFontFamily, fontSize: 12 }),
  },
  '& .location-cell-status': {
    display: 'block',
    cursor: 'pointer',
    width: 'fit-content',
    '& .location-cell-status-inline': {
      display: 'inline',
      borderBottom: '1px dashed #0078D4',
      color: '#D83B01',
      '& .status-icon': {
        float: 'none',
        marginRight: 5,
      },
    },
  },

  '& .status-icon .status_warning': warningIconStyle({ iconFontFamily }),
  '& .popup.popup-location-status': {
    display: 'block !important',
    color: '#323130',
    width: 350,
    maxWidth: 350,
    '& .popup__contents': {
      position: 'relative',
      '& .location-status-container': {
        padding: '18px 25px',
        backgroundColor: '#fff',
      },
    },
    '& .popup__close': {
      display: 'none',
    },
    '& h3': {
      marginTop: 0,
      marginBottom: 10,
      fontSize: 20,
      lineHeight: '28px',
      fontWeight: 600,
      border: 'none',
    },
    '& p': {
      fontSize: 12,
      lineHeight: '22px',
    },
  },
  '& .popover': {
    '& .arrow': {
      position: 'absolute',
    },
    '&.right, &.left': {
      '& .arrow': {
        top: '50%',
      },
    },
    '&.top, &.bottom': {
      '& .arrow': {
        left: '50%',
      },
    },
  },
});
